import { useMemo, useContext } from "react"
import DataIntegrator from "gatherers/data-integrator"
import MultiLineGraph from "renderers/multi-line-graph"
import { createPerformanceCumulativeMultiDateQuery } from "gatherers/multi-date/cumulative-performance"
import { transformPerformanceData, useCurrentPerformanceItems } from "connected-components/graph/hooks/use-performance-items"
import { filterItemsWithData } from "connected-components/graph/helpers"
import { MODEL_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { GRAPH_CONTEXT_SHAPE } from "../../prop-types"
import { useIntradayMode } from "connected-components/dashboard/hooks/use-intraday-mode"
import { PERFORMANCE_CONTEXT } from "./context"
export default function PerformanceGraph({ modelMetadata, context }) {
  const { startDate, performanceStartDate, performanceEndDate, base, instrument, disabledItems, setDisabledItems, setOnlyItem, enableAllItems } = useContext(context)
  const { selectedCategory } = useContext(PERFORMANCE_CONTEXT)
  // We ignore the base if we are in intraday mode to keep the queries consistent
  // since we also ignore the base for intraday simulation queries
  const [{ isIntradayMode }] = useIntradayMode()

  const categories = useMemo(() => {
    return modelMetadata.categories.map(({ id, label, color }) => ({
      id,
      label,
      color,
    }))
  }, [modelMetadata])

  const factorsMetadata = useMemo(() => {
    return modelMetadata.factors
  }, [modelMetadata])

  const currentItems = useCurrentPerformanceItems({
    categories,
    factorsMetadata,
    disabledItems,
    selectedCategory,
  })

  const gatherers = useMemo(() => {
    return [createPerformanceCumulativeMultiDateQuery(
      modelMetadata.id,
      instrument,
      base,
      performanceStartDate,
      performanceEndDate,
      isIntradayMode,
    )]
  }, [modelMetadata, instrument, performanceStartDate, performanceEndDate, base, isIntradayMode])

  return <DataIntegrator
    dataTransform={data => transformPerformanceData(data, categories)}
    metrics={gatherers}
    Renderer={MultiLineGraph}
    rendererProps={{
      items: currentItems,
      filterItems: filterItemsWithData,
      endDate: performanceEndDate,
      startDate,
      setItems: setDisabledItems,
      setOnlyItem,
      enableAllItems,
      loadingMessage: "Loading performance data...",
      errorMessage: "Failed to load performance data. Please try again.",
      emptyMessage: "No performance data available.",
    }}
  />
}

PerformanceGraph.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  context: GRAPH_CONTEXT_SHAPE.isRequired,
}
